import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OdborModel} from "@app/doss/models/odbor.model";
import {OdborComponent} from "@app/doss/components/odbor/odbor.component";
import {ClassName} from "@app/common/enums/class-name.enum";
import {DialogService} from "@app/common/services/dialog.service";
import {TableServiceDoss} from "@app/doss/services/table-service-doss.service";
import * as _ from "lodash";
import {DotcenyOrganService} from "@app/doss/services/dotceny-organ.service";
import {ValidationUtils} from "@app/doss/utils/validation.utils";
import {ConfirmationComponent} from "@app/common/components/confirmation/confirmation.component";

@Component({
  selector: 'table-odbor',
  templateUrl: './table-odbor.component.html',
  styleUrls: ['./table-odbor.component.scss']
})
export class TableOdborComponent {
  @Input()
  akceSchema: string;

  @Input()
  dotcenyOrganId: number;

  @Input()
  odbor: OdborModel;

  @Input()
  columnNames: any;

  @Output()
  onChanged: EventEmitter<any> = new EventEmitter();

  public readonly ValidationUtils = ValidationUtils;

  private readonly TABLE_ID = 'odbor';

  constructor(private dotcenyOrganService: DotcenyOrganService,
              private tableService: TableServiceDoss,
              private dialogService: DialogService) {
    this.onOdborCancel = this.onOdborCancel.bind(this);
  }

  getColumnName(columnId: string) {
    if (this.columnNames && this.columnNames[columnId]) {
      return this.columnNames[columnId];
    }
    return this.tableService.getColumnById(this.TABLE_ID, columnId).name;
  }

  onOdborUpdate(): void {
    const dialog = this.dialogService.open(OdborComponent, {
      data: {
        akceSchema: this.akceSchema,
        dotcenyOrganId: this.dotcenyOrganId,
        odbor: _.cloneDeep(this.odbor)
      },
      className: ClassName.ADJUSTED_DIALOG
    });

    const sub = dialog.afterClosed.subscribe(async (odbor: OdborModel) => {
      if (odbor) {
        this.dotcenyOrganService.updateOdbor(this.akceSchema, odbor).then(() => this.onChanged.emit());
      }
      sub.unsubscribe();
    });
  }

  showCancelButton(): boolean {
    return this.odbor.id && !ValidationUtils.isNonEmptyArray(this.odbor.reseneUkony);
  }

  onOdborCancel(): void {
    const dialog = this.dialogService.open(ConfirmationComponent, {
      data: {
        msg: 'Opravdu chcete odbor smazat? Jeho obnovení nebude možné!',
      },
      className: ClassName.ADJUSTED_DIALOG,
    });

    const sub = dialog.afterClosed.subscribe((result: boolean) => {
      if (result) {
        this.dotcenyOrganService.cancelOdbor(this.akceSchema, this.odbor).then(() => this.onChanged.emit());
      }
      sub.unsubscribe();
    });
  }
}
